'use client';

import { c as _c } from "react/compiler-runtime";
import type { Draw, DrawNumber } from '@svenskaspelab/poolbetting/schema/draw';
import type { Definition } from '@svenskaspelab/poolbetting/schema/frameworks';
import type { BettingEvent, BettingEventId, Participant, ParticipantId } from '@svenskaspelab/poolbetting/schema/sport';
import type { ReactNode } from 'react';
import ParticipantInfoRow from './ParticipantInfoRow';
type ParticipantsInfoProps = {
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
  draw: Draw;
  drawParticipants: Record<ParticipantId, Participant>;
  bettingEvents: Record<BettingEventId, BettingEvent>;
  nrOfRows: number;
};

/**
 * Component that renders participant information for all events in a draw.
 *
 * @param props - Component properties containing draw and participant data
 * @param props.draw - The draw object containing event information
 * @param props.drawParticipants - Record mapping participant IDs to participant objects
 * @param props.bettingEvents - Record mapping betting event IDs to betting event objects
 * @param props.nrOfRows - Total number of betting coupons, used for layout purposes
 * @returns A React node displaying the participant information for all draw events
 */
export default function ParticipantsInfo(t0) {
  const $ = _c(11);
  const {
    draw,
    drawParticipants,
    bettingEvents,
    nrOfRows
  } = t0;
  let t1;
  if ($[0] !== bettingEvents || $[1] !== draw.events || $[2] !== drawParticipants || $[3] !== nrOfRows) {
    let t2;
    if ($[5] !== bettingEvents || $[6] !== drawParticipants || $[7] !== nrOfRows) {
      t2 = drawEvent => {
        const eventParticipants = drawEvent.status === "COMPLETE" ? bettingEvents[drawEvent.bettingEventId]?.participants.map(participantId => drawParticipants[participantId]) : undefined;
        return <ParticipantInfoRow key={drawEvent.eventDescription} eventParticipants={eventParticipants} eventNumber={drawEvent.eventNumber} eventDescription={drawEvent.eventDescription} nrOfRows={nrOfRows} />;
      };
      $[5] = bettingEvents;
      $[6] = drawParticipants;
      $[7] = nrOfRows;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = draw.events.map(t2);
    $[0] = bettingEvents;
    $[1] = draw.events;
    $[2] = drawParticipants;
    $[3] = nrOfRows;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="row-span-9 row-start-2 grid grid-rows-subgrid">{t1}</div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}